import { GlyphRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { MathGlyphPicker, MathPickerContribution } from "../constants";

import { DefaultMathGlyphPicker } from "./glyph-picker";

let loadGlyphPick = !1;

export function bindGlyphMathPickerContribution(container) {
    loadGlyphPick || (loadGlyphPick = !0, container.bind(MathGlyphPicker).toDynamicValue((() => new DefaultMathGlyphPicker(resolveContainerBinding(container, GlyphRender)))).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathGlyphPicker));
}
//# sourceMappingURL=glyph-module.js.map
